/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import Markdown from 'react-markdown/with-html';
import Spinner from 'app/components/commons/Spinner';
import t from 'app/utils/translate';

type Props = {
  className: string,
  content: string,
  errorMessages: Array<Object>,
  isLoading: boolean,
  scheme: 'light' | 'dark'
};

function StaticContentInner({ className, content, errorMessages, isLoading, scheme }: Props) {
  if (isLoading) {
    return <Spinner center kind={scheme} />;
  }

  if (errorMessages.length > 0) {
    return <span>{t('Content not found')}</span>;
  }

  return <Markdown className={className} escapeHtml={false} source={content} />;
}

function mapStateToProps({ settings }) {
  return {
    scheme: settings.darkMode ? 'light' : 'dark'
  };
}
export default connect(mapStateToProps)(StaticContentInner);
